import { useExclusiveFilters } from '@/services/api/hooks/exclusiveFilters';
import { useBuildOrgTree } from '@/services/org/useBuildOrgTree';
import { useMemo } from 'react';
import { ProcessedOrgTree } from '@/components/org/TenantRestrictionTree';

export const useProcessOrgTreeForProductRestrictions = (productId?: string) => {
  const [orgTree] = useBuildOrgTree();
  const [filters] = useExclusiveFilters();

  const filtersForProduct = filters.filter(f => f.daasCatalogItem.id === productId);

  return useMemo(() => {
    return orgTree
      .filter(msp => msp.customers.length > 0)
      .map(msp => {
        return {
          ...msp,
          customers: msp.customers.map(customer => {
            return {
              ...customer,
              checked: Boolean(filtersForProduct.find(f => f.company?.id === customer.customerId))
            };
          }),
          checked: Boolean(filtersForProduct.find(f => f.partner?.id === msp.mspId))
        };
      }) as ProcessedOrgTree[];
  }, [orgTree]);
};
